import React, { useMemo, useRef } from "react";
import { Card, Button } from "react-bootstrap";
import { CityFilter } from "./city-filter/CityFilter";
import { CityTable } from "./city-table/CityTable";
import { useCityUIContext } from "./CityUIContext";

export function CityCard({
  handleAddNewCityShow,
  handleFilterValues,
  isLoading,
  cityList,
  filterValues,
  handleReset,
  cityListTotalCount,
  currentPage,
  setCurrentPage,
}) {
  const cityUIContext = useCityUIContext();
  const cityUIProps = useMemo(() => {
    return {
      ids: cityUIContext.ids,
      queryParams: cityUIContext.queryParams,
      setQueryParams: cityUIContext.setQueryParams,
      openReceiptDialog: cityUIContext.openReceiptDialog,
      openDeleteDialog: cityUIContext.openDeleteDialog,
      openEditDialog: cityUIContext.openEditDialog,
    };
  }, [cityUIContext]);
  const myRef = useRef(null);
  const onhandleReset = () => {
    myRef.current.click();
  };

  return (
    <>
      <Card className="card-custom card-stretch make-payment-wrapper">
        <Card.Header className="align-items-center border-bottom mt-4 d-none d-lg-flex">
          <h3 className="card-title align-items-start flex-column">
            <span className="font-weight-bold text-dark">Cities</span>
          </h3>

          <button
            type="button"
            className="btn btn-secondary btn-lg"
            // disabled={false}
            onClick={onhandleReset}
          >
            Reset
          </button>

          <Button
            variant="btn btn-light-primary btn-lg "
            onClick={handleAddNewCityShow}
          >
            New City
          </Button>
        </Card.Header>
        <Card.Body>
          <CityFilter
            filterValues={handleFilterValues}
            handleReset={handleReset}
            myRef={myRef}
          />
          <CityTable
            isLoading={isLoading}
            cityList={cityList}
            filterValues={filterValues}
            cityListTotalCount={cityListTotalCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </Card.Body>
      </Card>
    </>
  );
}
